export default __webpack_public_path__ + "static/media/empty__cart.5a023f8c.jpg";